<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  <div style="color:green" [innerHTML]="data.text"></div>
  <div style="color:green" [innerHTML]="data.info"></div>
  <br>
  <div>
    <textarea value="{{ data.notes }}" (change)="data.notes = $event.target.value" cdkFocusInitial style="height: 260px; width: 550px"></textarea>
  </div> 
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="data.showCancel" class="btn btn-light" mat-button mat-dialog-close>Cancel</button>
  <button class="btn btn-primary" mat-button [mat-dialog-close]="data">Save</button>
</mat-dialog-actions>
